import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { PricingsListQuery, GetPricingsInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_PRICINGS_LIST = gql`
    query pricingsList($input: GetPricingsInput!) {
        pricings (input: $input) {
            nodes {
                description
                id
                minServiceFees
                currencyCode
                billingItemCount
            }
        }
    }
`;

export const queryPricingList = async (
    client: ApolloClient<NormalizedCacheObject>,
    filters: {
        description?: string;
        id?: string;
        minServiceFees?: number;
    }
) => {
    
    const { description, id, minServiceFees } = filters as GetPricingsInput;
    const { data, errors } = await client.query<PricingsListQuery>({
        query: QUERY_PRICINGS_LIST,
        variables: { 
          input: {
            description,
            id,
            minServiceFees,
          }  
        }
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.pricings?.nodes;
};